import { Search } from "@mui/icons-material";
import { Button, Divider, Grid, InputBase, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { IMetaData } from "../../../Components/Dialog/WSCommonDialog";
import Notes from "../../Notes/Notes";
import { openPopUp } from "../../../Components/Dialog/OpenNewModal";
import { callAPI, createObject, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useNavigate, useParams } from "react-router-dom";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";

export const OverViewWorkOrder: React.FC<any> = React.memo((props) => {
  const isMobile = IsSmallScreen();
  AllPermissions.getInstance();
const { add, edit, remove, view } = AllPermissions.getWorkOrderPermission;
  const navigate = useNavigate();
  const params = useParams();
  const [workOrderData, setWorkOrderData] = useState<any>([])
  const id = params?.id;
  const [resetLoad, setResetLoad] = useState(false)
  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "customerName",
      tooltip: true,
      type: 'default'
    },
    {
      header: "No",
      fieldName: "orderNumber",
      type: 'default'
    },
    {
      header: "Rate",
      fieldName: "rate",
      type: 'default',
      isHide: isMobile
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined,"Print"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },
  ];
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`order/${row?.id}`)
    }
    else if (action === "Print") {
      navigate(`/order/print/${row?.id}`);
    }
  }

    useEffect(() => {
      const getQuotations = async () => {
        try {
          setResetLoad(false)
          const response: any = await callAPI(`workorders/lead/${id}`, Method.GET, null, null);
          setWorkOrderData(response?.data || []);
        }
        catch (e) {
        }
      }
      getQuotations();
    }, [resetLoad])
    const handleWorkOrderAddClick = () => {
      navigate(`order`)
    }
    return (
      <Grid>
        <Grid container spacing={2} sx={{ marginTop: 2 }}>
          {view?<Grid item xs={12}>
            <WSDataGrid
              id="workOrderGrid"
              columns={columns}
              title="Work Orders"
              data={workOrderData}
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
              addButton={add?{ label: "New", color: "secondary" }:undefined}
              onAddButtonClick={handleWorkOrderAddClick}
            />
          </Grid>
          :<PermissionDenied/>
        }
        </Grid>
      </Grid>
    );
  });
